import { useQuery } from 'react-query';

import * as authService from 'resources/auth/auth.service';
import * as userHelpers from 'resources/user/user.helpers';
import userService from 'resources/user/user.service';

import * as storageService from 'services/storage.service';

const loadUser = async () => {
  const authUser = authService.getAuth();

  if (!authUser) {
    return null;
  }

  const user = await userService.getByAuthId(authUser.id);

  if (!user) {
    return null;
  }

  const isClient = userHelpers.isClient(user);

  if (isClient) {
    const realtors = await userService.getUsersByIds(user.realtor_ids);

    const promises = realtors.map(userService.attachAvatarUrl);

    const result = await Promise.all(promises);

    user.realtors = result;
  }

  if (user.avatar_url) {
    const avatarUrl = await storageService.getAvatarUrl(user.avatar_url);

    user.avatar_id = user.avatar_url;
    user.avatar_url = avatarUrl;
  }

  return user;
};

export default function useCurrentUser(queryOptions) {
  return useQuery('user.currentUser', loadUser, queryOptions);
}
